<template>
  <img
    class="nav-icon"
    :src="navIcon"
    alt=""
    :style="{
      backgroundImage: `url(${defaultIcon})`
    }"
    onload="this.style.background = 'none'"
  >
</template>

<script>
import defaultIcon from 'public/images/icon/default-icon.png'

export default {
  props: {
    image: {
      type: String,
      default: defaultIcon
    }
  },
  setup () {
    return {
      defaultIcon
    }
  },
  computed: {
    navIcon () {
      return this.image || defaultIcon
    }
  }
}
</script>

<style scoped>
.nav-icon {
  width: 28px;
  height: 28px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 25px 25px;
  vertical-align: top;
}
</style>
